import { Empresa } from '../empresas';
import { Perfil } from '../perfil';
import { UsuarioEmpresa } from '../usuario-empresa';

export enum UsuarioSituacao {
  ATIVO = 'A',
  INATIVO = 'I',
  PENDENTE = 'P'
}

export enum UsuarioTipo {
  ADMINISTRATIVO = 'A',
  COORDENADOR = 'C',
  DIRETOR = 'D'
}

export interface Usuario {
  readonly id?: number | null;
  readonly login?: string | null;
  readonly senha?: string | null;
  readonly nome?: string | null;
  readonly sobrenome?: string | null;
  readonly email?: string | null;
  readonly cpf?: string | null;
  readonly situacao?: UsuarioSituacao | null;
  readonly dataInclusao?: string | null;
  readonly perfil?: Perfil | null;
  readonly tipo?: UsuarioTipo | null;
  readonly telefone?: string | null;
  readonly foto?: string | null;
  readonly tema?: string | null;
  readonly idUltimoSubProjeto?: number | null;
  readonly dataUltimoAcesso?: string | null;
  readonly empresa?: Empresa | null;
  empresasId?: number[] | null;
  readonly usuarioEmpresas?: UsuarioEmpresa[] | null;
}
